"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const react_1 = __importStar(require("react"));
const Paths_1 = require("../../../shared/Icons/Paths");
const Icon_styles_1 = require("./Icon.styles");
const Icon = (0, react_1.forwardRef)((_a, forwardedRef) => {
    var { color = "zinc", name, appearance = "outline", rotate = "0", size = "medium" } = _a, props = __rest(_a, ["color", "name", "appearance", "rotate", "size"]);
    let validAppearance = appearance;
    // TODO: ask designers to provide both appearance for each icons
    if (!(name in Paths_1.paths[appearance])) {
        console.error(`Icon with name "${name}" does not exist in "${appearance}". Please change the appearance to "${appearance === "outline" ? "solid" : "outline"}".`);
        // Default to display a valid icon
        validAppearance = appearance === "outline" ? "solid" : "outline";
    }
    const Path = Paths_1.paths[validAppearance][name];
    return (react_1.default.createElement(Icon_styles_1.StyledIcon, Object.assign({ "$color": color, "$size": size, "$rotate": rotate, ref: forwardedRef, viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": !props["aria-label"], role: "img" }, props),
        react_1.default.createElement("g", null,
            react_1.default.createElement(Path, { colour: "inherit" }))));
});
exports.Icon = Icon;
//# sourceMappingURL=Icon.js.map